import Command from './command';
import CommandResult from './command-result';
export default Command.extend({
  processZeroWidth() {
    return this._applyToAllBlocks();
  },
  processSingleBlock() {
    return this._applyToAllBlocks();
  },
  processMultiBlock() {
    return this._applyToAllBlocks();
  },
  _applyToAllBlocks() {
    let selection = this.get('selection');
    let selectedBlocks = selection.get('selectedBlocks');
    let selectedBlockLength = selectedBlocks.get('length');
    let options = this.get('options');
    let action = this.get('options.action');
    let blockRange, block, firstBlockMutationResult;
    for (let i = 0; i < selectedBlockLength; i++) {
      block = selectedBlocks.objectAt(i);
      blockRange = this._blockRangeForSelection(block, selection);
      if (i === 0) {
        firstBlockMutationResult = block.toggleEntity(action, blockRange, options);
      } else if (firstBlockMutationResult.get('added')) {
        block.addEntity(action, blockRange, options);
      } else {
        block.removeEntity(action, blockRange, options);
      }
      if (options.action === 'anchor') {
        this.collapseSelectionToRight();
      }
    }
    let result = {};
    if (options.action === 'marker') {
      if (this.get('firstSelectedBlock.isListType')) {
        result.markerId = this.get('firstSelectedBlock.blockList').objectAt(this.get('selection.startItemIndex')).get('entities.lastObject.id');
      } else {
        result.markerId = this.get('firstSelectedBlock.entities.lastObject.id');
      }
    }
    return CommandResult.create(result);
  }
});